/** Grymwyrd Traducción al español para la función de Juego / VTT. */
export const playEs = {
  // CampaignList
  'play.campaigns.heading': 'Mis Campañas',
  'play.campaigns.signIn': 'Inicia sesión',
  'play.campaigns.signInToSee': 'para ver las campañas a las que te has unido.',
  'play.campaigns.fallbackNotice': 'Mostrando campañas de ejemplo — no se pudo cargar tu lista.',
  'play.campaigns.loading': 'Recordando tus sagas…',
  'play.campaigns.empty': 'Aún no te has unido a ninguna campaña.',
  'play.campaigns.assignedCharacter': 'Personaje Asignado',
  'play.campaigns.unassigned': 'Sin Asignar',
  'play.campaigns.noCharactersYet': 'Sin personajes aún',
  'play.campaigns.enterCampaign': 'Entrar a la campaña',

  // CampaignPage — VTT prototype
  'play.vtt.theTable': 'La Mesa',
  'play.vtt.launch': 'Lanzar VTT',
  'play.vtt.iframeTitle': 'Grymwyrd VTT — campaña {campaignId}',
  'play.vtt.veilHeadline': 'El velo entre mesa y relato es fino aquí.',
  'play.vtt.prototypeIntro':
    'La mesa de juego virtual en tiempo real es una fase posterior. El prototipo interactivo se insertará en este marco — pulsa',
  'play.vtt.prototypeOutro': 'para preparar el contenedor.',

  // CampaignPage — encyclopedia sidebar
  'play.codex.heading': 'Búsqueda Rápida en el Códice',
  'play.codex.searchPlaceholder': 'Busca un monstruo, hechizo, regla…',
  'play.codex.searchAriaLabel': 'Busca en la enciclopedia',
  'play.codex.searching': 'Escrutando…',
  'play.codex.noResults': 'Nada encontrado para "{q}".',
  'play.codex.hint': 'Escribe al menos dos letras para buscar en la enciclopedia viva sin abandonar tu mesa.',

  // CampaignPage — detail
  'play.campaign.fallbackTitle': 'Campaña',
  'play.campaign.fallbackDescription':
    'No se pudieron cargar los detalles de la campaña — aún puedes preparar tu personaje a continuación.',
  'play.campaign.seoTitle': 'Campaña',
  'play.campaign.noneSpecified': 'Ninguna campaña especificada.',
  'play.campaign.seoTitleNamed': '{title} — Juego',
  'play.campaign.seoTitleDefault': 'Campaña — Juego',
  'play.campaign.backToLobby': 'Volver al vestíbulo',
  'play.campaign.gm': 'DJ {gm}',
  'play.campaign.playersCount': '{count} jugadores',

  // CharacterSheet
  'play.sheet.savedToCodex': 'Guardado en tu códice.',
  'play.sheet.savedLocally': 'Guardado localmente (servidor no disponible).',
  'play.sheet.saveError': 'No se pudo guardar tu personaje — el almacenamiento no está disponible.',
  'play.sheet.loading': 'Desplegando la hoja…',
  'play.sheet.heading': 'Hoja de Personaje',
  'play.sheet.avatarAlt': "Avatar de {name}",
  'play.sheet.unclaimedHero': 'Héroe sin reclamar',
  'play.sheet.abilityCheck': 'Tirada de {ability} ({formula}):',
  'play.sheet.name': 'Nombre',
  'play.sheet.namePlaceholder': 'Errante sin nombre',
  'play.sheet.level': 'Nivel',
  'play.sheet.speciesLabel': 'Ancestría / Especie',
  'play.sheet.loadingOption': 'Cargando…',
  'play.sheet.selectSpecies': 'Selecciona especie',
  'play.sheet.classLabel': 'Clase',
  'play.sheet.selectClass': 'Selecciona clase',
  'play.sheet.abilityScores': 'Habilidades',
  'play.sheet.abilityScoresHint': '(haz clic en el modificador para tirar)',
  'play.sheet.abilityScoreAria': 'Puntuación de {ability}',
  'play.sheet.rollCheckAria': 'Tirar un chequeo de {ability}',
  'play.sheet.hp': 'PV',
  'play.sheet.maxHp': 'Máx. PV',
  'play.sheet.ac': 'CA',
  'play.sheet.backstory': 'Trasfondo',
  'play.sheet.backstoryPlaceholder': '¿Qué oscuridad trajo esta alma a la mesa?',
  'play.sheet.canonCandidate': 'Candidato al Canon',
  'play.sheet.canonCandidateHint': 'Elige este personaje para consideración como parte del canon vivo de Grymwyrd.',
  'play.sheet.saving': 'Guardando…',
  'play.sheet.saveCharacter': 'Guardar Personaje',

  // CreateGameModal
  'play.create.errorNoName': 'Dale un nombre a tu mesa.',
  'play.create.errorNoSystem': 'Elige un sistema de juego.',
  'play.create.you': 'Tú',
  'play.create.errorCreate': 'El ritual falló — tu mesa no pudo ser creada. Inténtalo de nuevo en breve.',
  'play.create.modalTitle': 'Convocar una Mesa',
  'play.create.successCopy': 'Tu mesa está lista. Comparte este enlace de invitación para convocar a tus jugadores.',
  'play.create.copyInviteAria': 'Copiar enlace de invitación',
  'play.create.copied': 'Copiado',
  'play.create.copy': 'Copiar',
  'play.create.done': 'Hecho',
  'play.create.tableName': 'Nombre de la Mesa',
  'play.create.tableNamePlaceholder': 'p. ej. La Bóveda del Luto',
  'play.create.quickStart': 'Inicio Rápido',
  'play.create.quickStartAria': 'Presets de inicio rápido',
  'play.create.customPreset': 'Personalizado',
  'play.create.customPresetDesc': 'Comienza desde cero',
  'play.create.gameSystem': 'Sistema de Juego',
  'play.create.loadingSystems': 'Cargando sistemas…',
  'play.create.systemFromPreset': '{system} (del preset)',
  'play.create.systemDefault': 'Grymwyrd Cataclismo (predeterminado)',
  'play.create.tags': 'Etiquetas',
  'play.create.tagsUpTo': '(hasta {count})',
  'play.create.removeTagAria': 'Eliminar etiqueta {tag}',
  'play.create.tagLimitReached': 'Límite de etiquetas alcanzado',
  'play.create.tagPlaceholder': 'horror, one-shot…',
  'play.create.maxPlayers': 'Máx. Jugadores:',
  'play.create.cancel': 'Cancelar',
  'play.create.convening': 'Convocando…',
  'play.create.createTable': 'Crear Mesa',

  // JoinPage
  'play.join.finding': 'Buscando la mesa…',
  'play.join.expiredHeading': 'Esta invitación ha expirado',
  'play.join.expiredBody': 'Los códigos caducan por seguridad. Pídele a tu anfitrión uno nuevo.',
  'play.join.browseLiveTables': 'Explora mesas en directo',
  'play.join.errorHeading': 'No pudimos alcanzar la mesa',
  'play.join.errorBody': 'Algo salió mal al buscar tu invitación. Comprueba tu conexión e intenta de nuevo.',
  'play.join.tryAgain': 'Reintentar',
  'play.join.defaultTableTitle': 'Una mesa de Grymwyrd',
  'play.join.invited': 'Te han invitado a tomar asiento.',
  'play.join.signInToSeat': 'Inicia sesión para tomar tu asiento',
  'play.join.createAccount': '¿Nuevo aquí? Crea una cuenta gratuita',
  'play.join.opensAfterSignIn': 'La mesa se abre después de que inicies sesión.',

  // PlayLobbyPage
  'play.lobby.seoTitle': 'Juego — Mesa Virtual',
  'play.lobby.seoDescription':
    'Encuentra una mesa, únete a una sesión en directo y forja tu leyenda en la mesa virtual de Grymwyrd.',
  'play.lobby.eyebrow': 'Mesa Virtual',
  'play.lobby.title': 'Juego',
  'play.lobby.subtitle':
    'Reúne tu aquelarre. Lanza los dados. Toma asiento en una mesa donde cada decisión resuena en el canon vivo de Grymwyrd.',
  'play.lobby.createGame': 'Crear Juego',
  'play.lobby.playNow': 'Juega Ahora — sin cuenta necesaria',
  'play.lobby.signInToHost': 'Inicia sesión para alojar tu propia mesa',

  // SessionListLive
  'play.live.heading': 'En Directo Ahora',
  'play.live.empty': 'No hay mesas en directo en esta hora. El velo está tranquilo — comienza la tuya.',
  'play.live.badge': 'En directo',
  'play.live.unknownSystem': 'Sistema desconocido',
  'play.live.gmSuffix': ' · DJ {gm}',
  'play.live.players': 'jugadores',

  // TableList — empty board
  'play.tables.emptyHeading': 'Aún no hay mesas abiertas',
  'play.tables.emptyBody':
    'El tablero está tranquilo por ahora. Sé el primero en acercarse — prueba la mesa de invitados al instante, sin cuenta necesaria.',
  'play.tables.tryGuestTable': 'Prueba la mesa de invitados',
  'play.tables.orUse': 'O usa',
  'play.tables.createGame': 'Crear Juego',
  'play.tables.aboveToHost': 'arriba para alojar la tuya.',

  // TableList — waitlist
  'play.waitlist.joinError': 'No se pudo unir a la lista de espera — inténtalo de nuevo.',
  'play.waitlist.leaveError': 'No se pudo salir de la lista de espera — inténtalo de nuevo.',
  'play.waitlist.join': 'Unirse a la lista de espera',
  'play.waitlist.leaving': 'Saliendo…',
  'play.waitlist.leave': 'Salir de la lista de espera',
  'play.waitlist.joining': 'Uniéndose…',

  // TableList — board
  'play.tables.heading': 'Mesas Abiertas',
  'play.tables.openSeatOnly': 'Solo asientos abiertos',
  'play.tables.systemFilterPlaceholder': 'Sistema…',
  'play.tables.systemFilterAria': 'Filtrar por sistema',
  'play.tables.tagsFilterPlaceholder': 'Etiquetas (separadas por comas)…',
  'play.tables.tagsFilterAria': 'Filtrar por etiquetas',
  'play.tables.fetchError': 'No se pudo alcanzar el tablero en directo — el vestíbulo no está disponible temporalmente.',
  'play.tables.loading': 'Reuniendo mesas…',
  'play.tables.untitledTable': 'Mesa sin título',
  'play.tables.full': 'Llena',
  'play.tables.seatedCount': '{count} sentados',
  'play.tables.viewTable': 'Ver Mesa',

  // ── Live chat (P-E) — per-recipient translation (Option A) ────────────────
  'chat.heading': 'Chat de Mesa',
  'chat.empty': 'Sin mensajes aún. Di algo a la mesa.',
  'chat.inputPlaceholder': 'Mensaje a la mesa…',
  'chat.inputAria': 'Mensaje de chat',
  'chat.send': 'Enviar',
  'chat.translatedFrom': 'Traducido de {lang}',
  'chat.original': 'Original',
  'chat.showOriginal': 'Mostrar original',
  'chat.showTranslation': 'Mostrar traducción',
  'chat.showOriginalsAll': 'Mostrar originales',
  'chat.showTranslationsAll': 'Mostrar traducciones',
}
